import script from "./UiModalPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiModalPage.vue?vue&type=script&setup=true&lang=ts"

import "./UiModalPage.vue?vue&type=style&index=0&id=0c2c76b9&lang=css"

const __exports__ = script;

export default __exports__